/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnUpRightIcon16Regular = forwardRef('ArrowDUturnUpRightIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.998.44a.75.75 0 0 0-.996 1.12l3.025 2.69H7.5a5.75 5.75 0 1 0 0 11.5h3.75a.75.75 0 0 0 0-1.5H7.5a4.25 4.25 0 0 1 0-8.5h4.527L9.002 8.44a.75.75 0 1 0 .996 1.12l3.66-3.252a1.75 1.75 0 0 0 0-2.616L9.997.439Z" })));
});
